export default __webpack_public_path__ + "static/media/hiw_4.d3f0b2b7.svg";